module.exports = __webpack_public_path__ + "img/ic24Add.6590f62d.svg";